<template>
  <span class="date-column">{{ formattedValue }}</span>
</template>

<script setup lang="ts">
import {computed} from 'vue';

import {formatCultureDate} from '@/use/formatCultureValue';

const props = defineProps<{
  value?: string | Date | null,
}>();

const formattedValue = computed(() => formatCultureDate(props.value));
</script>
